<div class="close-session-container">
  <p class="main-p">{{ 'SESSIONEND.TITLE' | translate }}</p>
  <p class="explain">{{ 'SESSIONEND.TEXT' | translate }}</p>
  <div class="btn-container">
    <button class="accept" (click)="closeModal(true)">Aceptar</button>
  </div>
</div>